import clsx from 'clsx';
import { ElementType, forwardRef, ReactNode } from 'react';

import css from './style.module.scss';

export type TypographyVariant =
	| 'h1'
	| 'h1-industry'
	| 'h2'
	| 'h2-industry'
	| 'h3'
	| 'h3-industry'
	| 'h4'
	| 'h5'
	| 'h5-regular'
	| 'h6'
	| 'h6-regular'
	| 'body-l'
	| 'body-m'
	| 'body-s'
	| 'body-xs'
	| 'button-l'
	| 'button-m'
	| 'button-s'
	| 'numbers-l'
	| 'numbers-m'
	| 'numbers-s';

export interface TypographyProps {
	variant: TypographyVariant;
	tag?: ElementType;
	className?: string;
	children: ReactNode;
	uppercase?: boolean;
	responsive?: boolean;
}

export const Typography = forwardRef<HTMLElement, TypographyProps>(function Typography(
	{ variant, tag: Component = 'div', className, children, uppercase = false, responsive = true },
	ref
) {
	return (
		<Component
			ref={ref as any}
			className={clsx(
				css.root,
				css[variant],
				className,
				uppercase && css.uppercase,
				responsive && css.responsive
			)}
		>
			{children}
		</Component>
	);
});
